export default __webpack_public_path__ + "static/media/frg--bbq-entertaining.00130393.png";